import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { APP_ROUTES } from './app.routes';
import { APP_CONFIG } from './core/config/app-config.token';
import { authInterceptor } from './core/http/auth.interceptor';
import { apiErrorInterceptor } from './core/http/api-error.interceptor';

const resolveApiBaseUrl = (): string => {
  if (typeof window === 'undefined') {
    return 'http://127.0.0.1:3000/api';
  }

  const protocol = window.location.protocol || 'http:';
  const hostname = window.location.hostname || '127.0.0.1';
  const port = window.location.port;

  if (port && port !== '80' && port !== '443') {
    return `${protocol}//${hostname}:3000/api`;
  }

  return `${protocol}//${hostname}/api`;
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(
      APP_ROUTES,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        apiErrorInterceptor
      ])
    ),
    {
      provide: APP_CONFIG,
      useValue: {
        apiBaseUrl: resolveApiBaseUrl()
      }
    }
  ]
};
